import React, { useState, useEffect } from "react";
import "./table.scss";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import axios from "axios";
import { useSelector } from "react-redux";

const List = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const userId = useSelector((state) => state.user.userId);
  const adminType = useSelector((state) => state.user.adminType);

  const [rows, setRows] = useState([]);

  // Fetch data based on adminType
  useEffect(() => {
    const fetchData = async () => {
      try {
        let res;
        if (adminType === "sAdmin") {
          // Fetch data from the User model if adminType is "sAdmin"
          res = await axios.get(`${BASE_URL}/api/users/findAllAdminUser`);
        } else {
          // Fetch data from the Member model if adminType is not "sAdmin"
          res = await axios.get(
            `${BASE_URL}/api/member/findAllMember/${userId}`
          );
        }

        setRows(res.data); // Set the fetched data to rows
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [adminType, userId]); // Adding dependencies to refetch data if adminType or userId changes

  return (
    <TableContainer component={Paper} className="table">
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            {/* Conditionally rendering table headers */}
            {adminType === "sAdmin" ? (
              <>
                <TableCell className="tableCell">Photo</TableCell>
                <TableCell className="tableCell">Club Name</TableCell>
                <TableCell className="tableCell">User Email</TableCell>
                <TableCell className="tableCell">Phone Number</TableCell>
                <TableCell className="tableCell">Village Name</TableCell>
                <TableCell className="tableCell">Admin Type</TableCell>
                <TableCell className="tableCell">address</TableCell>
              </>
            ) : (
              <>
                <TableCell className="tableCell">Photo</TableCell>
                <TableCell className="tableCell">Name</TableCell>
                <TableCell className="tableCell">Email</TableCell>
                <TableCell className="tableCell">Phone Number</TableCell>
                <TableCell className="tableCell">Position</TableCell>
                <TableCell className="tableCell">Role</TableCell>
                <TableCell className="tableCell">Status</TableCell>
              </>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row._id}>
              {/* Conditionally rendering row content */}
              {adminType === "sAdmin" ? (
                <>
                  <TableCell className="tableCell">
                    <div className="cellWrapper">
                      <img
                        src={row.clubIcon}
                        alt="Admin"
                        className="image"
                        onError={(e) => {
                          e.target.src = "/img/logo.png";
                        }}
                      />
                    </div>
                  </TableCell>
                  <TableCell className="tableCell">{row.clubName}</TableCell>
                  <TableCell className="tableCell">{row.email}</TableCell>
                  <TableCell className="tableCell">{row.phoneNumber}</TableCell>
                  <TableCell className="tableCell">{row.villageName}</TableCell>
                  <TableCell className="tableCell">{row.adminType}</TableCell>
                  <TableCell className="tableCell">{row.address}</TableCell>
                  {/* <TableCell className="tableCell">
                    <span className={`status ${row.status}`}>{row.status}</span>
                  </TableCell> */}
                </>
              ) : (
                <>
                  <TableCell className="tableCell">
                    <div className="cellWrapper">
                      <img
                        src={row.image}
                        alt={row.fullName}
                        className="image"
                        onError={(e) => {
                          e.target.src = "/img/logo.png";
                        }}
                      />
                    </div>
                  </TableCell>
                  <TableCell className="tableCell">
                    <div className="cellWrapper">{row.fullName}</div>
                  </TableCell>
                  <TableCell className="tableCell">{row.email}</TableCell>
                  <TableCell className="tableCell">{row.phoneNumber}</TableCell>
                  <TableCell className="tableCell">{row.position}</TableCell>
                  <TableCell className="tableCell">{row.role}</TableCell>
                  <TableCell className="tableCell">
                    <span className={`status ${row.status}`}>{row.status}</span>
                  </TableCell>
                </>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default List;
